import { ECHART_COLOR } from '@gp/constants/echarts';
import { toFirstUpperCase } from '@gp/utils/common';
import ZebraLegendIcon from '@gp/assets/svg/zebra-block.svg';
import BlockLegendIcon from '@gp/assets/svg/black-block.svg';
import forecastIcon from '@gp/assets/svg/icon-forecast.svg';
import budgetIcon from '@gp/assets/svg/icon-budget.svg';

// Budget 的 key
const BUDGET = 'budget';
// Actual or Forecast 的 key
const ACTUAL_FORECAST = 'af';
const ACTUAL = 'actual';
const FORECAST = 'forecast';
// Complete 的 key
const COMPLETE = 'complete';

const SERIE_NAMES_MAP: {
  [key: string]: string;
} = {
  [BUDGET]: 'Budget',
  [ACTUAL_FORECAST]: 'Actual or Forecast',
  [COMPLETE]: '% Complete',
};

const SERIE_ICONS_MAP: {
  [key: string]: any;
} = {
  [BUDGET]: /* ZebraLegendIcon */budgetIcon,
  [ACTUAL_FORECAST]: BlockLegendIcon,
  [COMPLETE]: null,
};

const AF_LEGENDS_MAP: IGeneralLegend[] = [
  {
    key: ACTUAL,
    text: toFirstUpperCase(ACTUAL),
    dotColor: '#A3A5B2',
    showIcon: false,
    isNotClickEvent: true,
  },
  {
    key: FORECAST,
    text: toFirstUpperCase(FORECAST),
    showDot: false,
    showIcon: true,
    icon: forecastIcon,
    iconStyle: {
      width: 8,
      height: 8,
    },
    isNotClickEvent: true,
  },
];

const SERIE_LEGENDS: IGeneralLegend[] = [
  ...AF_LEGENDS_MAP,
  {
    key: BUDGET,
    text: SERIE_NAMES_MAP?.[BUDGET],
    dotColor: ECHART_COLOR?.[0],
    showDot: false,
    showIcon: true,
    icon: SERIE_ICONS_MAP?.[BUDGET],
    iconStyle: {
      width: 8,
      height: 8,
    },
  },
  /* {
    key: ACTUAL_FORECAST,
    text: SERIE_NAMES_MAP?.[ACTUAL_FORECAST],
    dotColor: ECHART_COLOR?.[0],
    showIcon: true,
    icon: SERIE_ICONS_MAP?.[ACTUAL_FORECAST],
  }, */
  {
    key: COMPLETE,
    text: SERIE_NAMES_MAP?.[COMPLETE],
    dotColor: ECHART_COLOR?.[7],
    showIcon: false,
    icon: SERIE_ICONS_MAP?.[COMPLETE],
  },
];

export {
  BUDGET,
  ACTUAL_FORECAST,
  ACTUAL,
  FORECAST,
  COMPLETE,
  SERIE_NAMES_MAP,
  SERIE_ICONS_MAP,
  SERIE_LEGENDS,
  AF_LEGENDS_MAP,
};
